﻿export class ChatsService {
  constructor({ chatsGateway, projectsService } = {}) {
    if (!chatsGateway) {
      throw new Error('chatsGateway is required');
    }
    this.gateway = chatsGateway;
    this.projectsService = projectsService || null;
  }

  async loadSidebarData({ limit = 50, offset = 0 } = {}) {
    const [unfiled, projects] = await Promise.all([
      this.gateway.listUnfiledChats({ limit, offset }),
      this.#listProjects(),
    ]);

    const normalizedProjects = [];
    for (const project of projects) {
      if (!project || !project.id) {
        continue;
      }
      const chats = await this.gateway.listTeamChats(project.id, { limit, offset });
      normalizedProjects.push({
        id: project.id,
        name: project.name || 'Project',
        chats,
      });
    }

    return {
      unfiled,
      projects: normalizedProjects,
    };
  }

  async listUnfiledChats({ limit = 50, offset = 0 } = {}) {
    return this.gateway.listUnfiledChats({ limit, offset });
  }

  async listTeamChats(teamId, { limit = 50, offset = 0 } = {}) {
    if (!teamId) {
      return [];
    }
    return this.gateway.listTeamChats(teamId, { limit, offset });
  }

  async moveChat({ chatId, teamId } = {}) {
    return this.gateway.moveChat({ chatId, teamId });
  }

  async renameChat({ chatId, title } = {}) {
    return this.gateway.renameChat({ chatId, title });
  }

  async deleteChat(chatId) {
    return this.gateway.deleteChat(chatId);
  }

  async loadChat(chatId) {
    return this.gateway.loadChat(chatId);
  }

  async #listProjects() {
    if (!this.projectsService || typeof this.projectsService.listProjects !== 'function') {
      return [];
    }
    const projects = await this.projectsService.listProjects();
    if (Array.isArray(projects)) {
      return projects;
    }
    if (projects && Array.isArray(projects.items)) {
      return projects.items;
    }
    return [];
  }
}

if (typeof window !== 'undefined') {
  window.AgileProServices = window.AgileProServices || {};
  window.AgileProServices.ChatsService = ChatsService;
}
